import React, { useContext } from 'react'
import styled from 'styled-components'
import { Button, Modal } from 'antd'
import { FormattedMessage } from 'react-intl'

import { availableLocales } from '../../../i18n/locales'
import { FlexRow } from '../../FlexboxReusables/FlexItems'
import { ParticipantCourseContext } from '../Context/ParticipantCourseContext'

const WelcomeModal = () => {
  const { displayWelcomeModal, setDisplayWelcomeModal } = useContext(ParticipantCourseContext)

  const neverShowMeAgain = () => {
    localStorage.setItem('neverDisplayWelcomeModal', 'true')
    setDisplayWelcomeModal(false)
  }

  return (
    <Modal
      centered
      title={<FormattedMessage id='courseForParticipant.welcomeModal.title' />}
      open={displayWelcomeModal}
      onCancel={() => setDisplayWelcomeModal(false)}
      footer={[
        <FlexRow key='someRow' justifyContent='space-between' width='100%'>
          <Button
            key="neverShowMeAgain"
            onClick={neverShowMeAgain}          
          >
            <FormattedMessage id='courseForParticipant.welcomeModal.neverShowModalAgain' />
          </Button>
          <Button
            key="submit"
            type="primary"
            onClick={() => setDisplayWelcomeModal(false)}
          >
            <FormattedMessage id='generic.start' />
          </Button>
        </FlexRow>
      ]}  
    >
      <p>
        <FormattedMessage id='courseForParticipant.welcomeModal.considerThisBeforeStarting' />
      </p>
      <ul>
        <ListItem>
          <FormattedMessage id='courseForParticipant.welcomeModal.appIsMultilanguage' values={{ localesCount: availableLocales.length }}/>
        </ListItem>
        <ListItem>
          <FormattedMessage id='courseForParticipant.welcomeModal.appIsResponsive' />
        </ListItem>
      </ul>
      <p>
        <FormattedMessage id='courseForParticipant.welcomeModal.glhf' />
      </p>
    </Modal>
  )
}

export default WelcomeModal

const ListItem = styled.li`
  margin: 0.5em 0;
`